module.exports = __webpack_public_path__ + "static/media/img-quem-somos.112e83c9.jpg";